export enum actionTypes {
    ADD_TRANSLATIONS = 'I18N:TRANSLATIONS:ADD',
    CLEAR_TRANSLATIONS = 'I18N:TRANSLATIONS:CLEAR',
    SET_DEFAULT_TRANSLATIONS = 'I18N:DEFAULT_TRANSLATIONS:SET',
    SHOW_TRANSLATION_KEYS = 'I18N:TRANSLATION_KEYS:SHOW'
}
